<template>
  <div class="mt-5" v-if="user">
    <h2>Bedriftsopplysninger</h2>
    <div class="section">
      <h4>
        Kontaktperson
      </h4>
      <table class="table">
        <tbody>
          <tr>
            <th>Navn</th>
            <td>{{ user.supplier.contact_name }}</td>
          </tr>
          <tr>
            <th>Telefonnummer</th>
            <td>{{ user.supplier.contact_phone }}</td>
          </tr>
          <tr>
            <th>E-postadresse</th>
            <td>{{ user.supplier.contact_email }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="section">
      <h4>
        Bedriftsopplysninger
      </h4>
      <table class="table">
        <tbody>
          <tr v-if="user.supplier.orgnr">
            <th>Organisasjonsnummer</th>
            <td>{{ user.supplier.orgnr }}</td>
          </tr>
          <tr v-if="user.supplier.bankgiro">
            <th>Bankgirokonto</th>
            <td>{{ user.supplier.bankgiro }}</td>
          </tr>
          <tr v-if="user.supplier.plusgiro">
            <th>Plusgirokonto</th>
            <td>{{ user.supplier.plusgiro }}</td>
          </tr>
          <tr v-if="user.supplier.bank_number">
            <th>Kontonummer</th>
            <td>{{ user.supplier.bank_number }}</td>
          </tr>
          <tr v-if="user.supplier.bank">
            <th>Bank</th>
            <td>{{ user.supplier.bank }}</td>
          </tr>
          <tr v-if="user.supplier.country_code !== 'NO'">
            <th>Iban</th>
            <td>{{ user.supplier.iban }}</td>
          </tr>
          <tr v-if="user.supplier.country_code !== 'NO'">
            <th>BIC/SWIFT</th>
            <td>{{ user.supplier.iban }}</td>
          </tr>
        </tbody>
      </table>
      <!-- <b-button variant="primary" @click="showForm()">Endre opplysninger</b-button> -->
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import SupportForm from '@/components/SupportForm.vue';

export default {
  components: {
    'support-form': SupportForm,
  },
  data() {
    return {
      panelInstance: null,
    };
  },
  computed: {
    ...mapGetters({
      user: 'auth/getUser',
    }),
  },
  methods: {
    showForm() {
      if (this.panelInstance) {
        this.panelInstance.show();

        //delete this.panelInstance;
      } else {
        this.panelInstance = this.$showPanel({
          component: SupportForm,
          width: '500px',
          keepAlive: true,
          props: {
            //any data you want passed to your component
          },
        });

        // this.panelInstance.promise.then(() => {
        //   delete this.panelInstance;
        // });
      }
    },
  },
};
</script>

<style scoped>
th {
  width: 50%;
}
</style>
